import store from '@/store';

// 最小的屏幕共享高度
export const MIN_SCREEN_SHARE_CPT_HEIGHT = 220;

// 最小的屏幕共享距离底部的距离
// 用来计算最大屏幕共享高度 => window.innerHeight - MIN_SCREEN_SHARE_CPT_DISTANCE_TO_BOTTOM
export const MIN_SCREEN_SHARE_CPT_DISTANCE_TO_BOTTOM = 328;

// 获取最大屏幕共享高度到底部的距离
export const getMaxScreenShareHeightToBottom = () => {
  return MIN_SCREEN_SHARE_CPT_DISTANCE_TO_BOTTOM;
};

// 获取最大屏幕共享高度
export const getMaxScreenShareHeight = (newHeight) => {
  newHeight = newHeight || window.innerHeight;
  return newHeight - getMaxScreenShareHeightToBottom();
};

// 屏幕共享礼物状态
export const SCREEN_SHARE_GIFT = {
  unprocessed: 3, // 未处理
  accepted: 4, // 已接受
  rejected: 5, // 已拒绝
  canceled: 6, // 已取消
};
